import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StackSidebarWatch } from "./PlayerSidebar.styles";
import type { PlayerSidebarProps } from "./PlayerSidebar.types";
import { UpcomingActivityItem } from "./UpcomingActivityItem.component";
import { CardTabsAttachment, CardTabsLink } from "../../components";
import { TeacherCard } from "../LearningActiviyModal/TeacherCard.component";
import { handleTeachersAndTutors } from "../LearningActiviyModal/utils";
import { SideBarBoxRestyle } from "../NavigationSidebar/SidebarBox.component";

export function PlayerSidebar({
  teachers,
  tutors,
  usefulLinks,
  tools,
  upcomingActivities,
  disabled,
  courseId,
  rootId
}: PlayerSidebarProps) {
  const { t } = useTranslation();

  const teachersWithRole = handleTeachersAndTutors(teachers, tutors, t);

  const hasTeachers = teachersWithRole.length > 0;
  const hasLinks = usefulLinks.length > 0;
  const hasTools = tools.length > 0;
  const hasUpcomingActivities = upcomingActivities.length > 0;

  if (!hasTeachers && !hasLinks && !hasTools && !hasUpcomingActivities) {
    return null;
  }

  return (
    <StackSidebarWatch
      id="player-sidebar"
      data-testid="player-sidebar-root"
      role="complementary"
      aria-label={ t("related_content") }
    >
      { hasTeachers && (
        <SideBarBoxRestyle title={ t("teachers") }>
          <Stack gap="1rem">
            { teachersWithRole.map((teacher, index) => (
              <TeacherCard
                key={ `player-sidebar-teacher-${teacher.id}-${index}` }
                image={ teacher.image }
                name={ teacher.completeName }
                role={ teacher.role }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
      { hasLinks && (
        <SideBarBoxRestyle title={ t("sidebar_links") }>
          <Stack gap="0.5rem">
            { usefulLinks.map((link, index) => (
              <CardTabsLink
                key={ `player-sidebar-link-${index}` }
                disabled={ disabled }
                description={ link.description }
                url_label={ link.url_label }
                url={ link.url }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
      { hasTools && (
        <SideBarBoxRestyle title={ t("sidebar_materials") }>
          <Stack gap="0.5rem">
            { tools.map((tool, index) => (
              <CardTabsAttachment
                key={ `player-sidebar-material-${index}` }
                disabled={ disabled }
                dimension={ tool.dimension }
                id={ tool.id }
                name={ tool.name }
                shortDescription={ tool.shortDescription }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
      { hasUpcomingActivities && (
        <SideBarBoxRestyle title={ t("sidebar_upcoming_activities") }>
          <Stack gap="0.5rem">
            { upcomingActivities.map((activity) => (
              <UpcomingActivityItem
                key={ `player-sidebar-upcoming-${activity.id}` }
                activity={ activity }
                courseId={ courseId }
                rootId={ rootId }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
    </StackSidebarWatch>
  );
}
